import { useMemo } from 'react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { AccessRights, LinkTarget } from '../../typings/common';
import { ProductAccess } from '../../typings/products';
import { RouteStyledLink, StyledLinkTheme } from '../StyledLink/StyledLink';
import { TextCell } from '../TextCell/TextCell';

import './ProductNameCell.css';

export interface ProductNameCellProps {
    productName: string;
    productLink: string;
    productAccess: ProductAccess;
    productPlaceIds: number[] | null;
    accessRights: AccessRights;
}

const BLOCK = 'product-name-cell';

export const ProductNameCell: React.FC<ProductNameCellProps> = React.memo(props => {
    const { productName, productAccess, productPlaceIds, accessRights, productLink } = props;

    const productAccessLabel: React.ReactNode = useMemo(() => {
        if (accessRights.canViewListOfInternalAdManagers) {
            return '';
        }

        switch (productAccess) {
            case ProductAccess.INTERNAL_AD_PUBLISHER:
                if (productPlaceIds) {
                    return `By Place: ${productPlaceIds.join(', ')}`;
                }
                return 'Full';
            case ProductAccess.INTERNAL_AD_READER:
                return 'Readonly';
            default:
                return '';
        }
    }, [productName, productAccess, accessRights]);

    return (
        <>
            <TextCell>
                <RouteStyledLink theme={StyledLinkTheme.blue} href={productLink} target={LinkTarget.blank}>
                    {productName}
                </RouteStyledLink>
            </TextCell>
            <TextCell cls={Bem.cls(BLOCK, 'text')}>{productAccessLabel}</TextCell>
        </>
    );
});
